import { z } from "zod";
import { LocaleCodeSchema } from "./locale.schemas.js";

export const localizedTextSchema = z.object({
  lang: LocaleCodeSchema,
  content: z.string(),
  translations: z.record(z.string(), z.string()).optional(),
});
